
<template>
  <div id="PlanKs_id_cont">
    <div class="ks-div mainContainer" v-if="!loading">
      <div class="ks-title">
        <div class="ks-title-top" id="ks-title-top" @click="fullPage()">{{sjData.cname}}</div>
        <div class="ks-title-bottom">
          <div class="ks-title-bg">
            <div class="progress" :style="width"></div>
          </div>
          <div class="disFlex between">
            <div>{{progress}}</div>
            <div>已完成 <span style="color: #0071BA;">{{tiji.length>0?(yidaNum+'/'+tiji.length):('0/'+tiji.length)}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="disFlex between" style="margin-top: 26px;position: relative;">
        <div class="ks-tiji" id="ks-tiji-divA">
          <div class="ks-ti-block" v-for="(item,i) in tiji" :id="'tijiid'+i">
            <div class="ks-ti-block-xh">{{i+1}}</div>
            <div v-if="item.itype=='1'">
              <div class="ks-ti-block-typeName">[单选题]</div>
              <div class="ks-ti-block-tiName">{{item.cname}}</div>
              <div v-for="(a,i) in item.dalist" :class="'radioTm radioTm'+i">
                <el-radio v-model="item.myanswer" :label="a.order" size="medium">{{a.conts}}</el-radio>
              </div>
            </div>
            <div v-if="item.itype=='2'">
              <div class="ks-ti-block-typeName">[多选题]</div>
              <div class="ks-ti-block-tiName">{{item.cname}}</div>
              <div v-for="(a,i) in item.dalist" :class="'checkboxTm checkboxTm'+i">
                <el-checkbox v-model="item.myanswer" :key="a.order" :label="a.order">{{a.conts}}</el-checkbox>
              </div>
            </div>
            <div v-if="item.itype=='3'">
              <div class="ks-ti-block-typeName">[判断题]</div>
              <div class="ks-ti-block-tiName">{{item.cname}}</div>
              <div class="radioTm radioTm0">
                <el-radio v-model="item.myanswer" label="1" size="medium">对</el-radio>
              </div>
              <div class="radioTm radioTm1">
                <el-radio v-model="item.myanswer" label="0" size="medium">错</el-radio>
              </div>
            </div>
            <div v-if="item.itype=='4'">
              <div class="ks-ti-block-typeName">[填空题]</div>
              <div class="ks-ti-block-tiName">
                <span v-for="a in item.dalist" class="tiankong-inp">
                  <span v-if="a.type=='text'">{{a.conts}}</span>
                  <el-input v-else v-model="a.conts" placeholder="请输入内容"></el-input>
                </span>
              </div>
            </div>
            <div v-if="item.itype=='5'">
              <div class="ks-ti-block-typeName">[简答题]</div>
              <div class="ks-ti-block-tiName">{{item.cname}}</div>
              <div>
                <el-input type="textarea" :rows="2" placeholder="请输入您的答案" v-model="item.myanswer"></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="ks-datika">
          <div class="disFlex between">
            <div class="ks-datika-name">答题卡</div>
            <div class="ks-datika-wcd"><span>完成度：</span><span style="color: #0071BA;">{{yidaNum}}/{{tiji.length}}</span>
            </div>
          </div>
          <div class="disFlex"
            style="align-items: center;margin: 20px 0;font-size: 14px;color: #333;letter-spacing: 1px;">
            <div class="small-block-yd"></div>已答
            <div class="small-block-wd"></div>未答
          </div>
          <div v-for="t in itypeList">
            <div class="ti-type">
              {{t=='1'?'单选题':''}}
              {{t=='2'?'多选题':''}}
              {{t=='3'?'判断题':''}}
              {{t=='4'?'填空题':''}}
              {{t=='5'?'简答题':''}}
            </div>
            <div class="disFlex" style="flex-wrap: wrap;" v-if="t=='1'">
              <div v-for="(item,i) in tiji"
                :class="item.myanswer||item.myanswer=='0'?'ti-xuhao-block active':'ti-xuhao-block'"
                v-if="item.itype=='1'" @click="goToTiji(i)">
                {{i+1}}
              </div>
            </div>
            <div class="disFlex" style="flex-wrap: wrap;" v-if="t=='2'">
              <div v-for="(item,i) in tiji" :class="item.myanswer.length>0?'ti-xuhao-block active':'ti-xuhao-block'"
                v-if="item.itype=='2'" @click="goToTiji(i)">{{i+1}}</div>
            </div>
            <div class="disFlex" style="flex-wrap: wrap;" v-if="t=='3'">
              <div v-for="(item,i) in tiji" :class="item.myanswer?'ti-xuhao-block active':'ti-xuhao-block'"
                v-if="item.itype=='3'" @click="goToTiji(i)">{{i+1}}</div>
            </div>
            <div class="disFlex" style="flex-wrap: wrap;" v-if="t=='4'">
              <div v-for="(item,i) in tiji" :class="item.myanswer?'ti-xuhao-block active':'ti-xuhao-block'"
                v-if="item.itype=='4'" @click="goToTiji(i)">{{i+1}}</div>
            </div>
            <div class="disFlex" style="flex-wrap: wrap;" v-if="t=='5'">
              <div v-for="(item,i) in tiji" :class="item.myanswer?'ti-xuhao-block active':'ti-xuhao-block'"
                v-if="item.itype=='5'" @click="goToTiji(i)">{{i+1}}</div>
            </div>
          </div>
          <div style="margin: 20px 0;">
            <el-button type="primary" class="tijiao-junazi" @click="onSubmit">提交</el-button>
          </div>
        </div>
      </div>


    </div>

  </div>
</template>

<script>
  import {
    format
  } from '@/assets/js/common.js';
  export default {
    name: 'PlanKs',
    props: ['KsBtnIsfixed'],
    data() {
      return {
        width: 'width:0%',
        progress: '0%',
        danxuanx: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
        tiji: [],
        yidaNum: 0,
        sjData: {},
        itypeList: [],
        startTime: '',
        loading: true,
        istj: false,
        isfirst: true
      }
    },
    methods: {
      // 获取答题情况
      getJincheng: function(newVal) {
        var yidaNum = 0;
        newVal.map((item) => {
          if (item.itype == '2') {
            if (item.myanswer.length > 0) {
              yidaNum++
            }
          }
          if (item.itype == '1' || item.itype == '5' || item.itype == '3') {
            if (item.myanswer || item.myanswer == '0') {
              yidaNum++
            }
          }
          // 填空题所有的空填完才算完成一题
          if (item.itype == '4') {
            var isqt = true
            item.dalist.map((a) => {
              if (a.type == 'input' && !a.conts) {
                isqt = false
              }
            });
            if (isqt) {
              item.myanswer = true
              yidaNum++
            } else {
              item.myanswer = false
            }
          };
        });
        this.yidaNum = yidaNum;
        this.progress = newVal.length > 0 ? (((yidaNum / newVal.length) * 100) + '%') : '0%';
        this.width = 'width:' + this.progress;
      },
      onSubmit: function() {
        if (this.yidaNum < this.tiji.length) {
          this.$confirm('还有题目未作答，确定要提交么？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            center: true,
            type: 'warning'
          }).then(() => {
            this.saveTj();
          }).catch(() => {
            // console.log('9562316046')
          });
        } else {
          this.saveTj();
        }
      },
      saveTj: function() {
        // 生成试卷  同一个时间  生成的试卷只可  提交一次
        if (sessionStorage.getItem('startTime') == this.startTime) {
          sessionStorage.setItem('startTime', '');
        } else {
          return;
        }

        const loading = this.$loading({
          lock: true,
          text: '试卷提交中，请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)',
          customClass: "loadclass"
        });

        var tijilist = this.tiji;
        var list = [];
        this.istj = true; //代表已提交
        tijilist.map((item) => {
          var fraction = 0;
          if (item.itype == '1') {
            fraction = this.sjData.itype1Fraction
          } else if (item.itype == '2') {
            fraction = this.sjData.itype2Fraction
          } else if (item.itype == '3') {
            fraction = this.sjData.itype3Fraction
          } else if (item.itype == '4') {
            fraction = this.sjData.itype4Fraction
          } else if (item.itype == '5') {
            fraction = this.sjData.itype5Fraction
          }
          var obj = {
            questionsid: item.id,
            itype: item.itype,
            fraction: fraction,
            conts: item.myanswer
          };
          var a = [];
          item.dalist.map((d) => {
            // 选择题
            if (item.itype == '1' && d.iscorrect == '1') {
              obj.daans = d.order;
            } else if (item.itype == '2' && d.iscorrect == '1') {
              // 多选题
              a.push(d.order);
            } else if (item.itype == '3') {
              // 判断题
              obj.daans = d.iscorrect;
            } else if (item.itype == '5') {
              obj.daans = d.keyword;
            }
          });
          if (item.itype == '2') {
            obj.daans = a.join(',');
            obj.conts = obj.conts.join(',');
          }
          list.push(obj);
        })
        var params = {
          productid: sessionStorage.getItem('planId'),
          papersid: this.sjData.id,
          startTime: this.startTime,
          list: JSON.stringify(list)
        };

        this.$axios.post('/kt/ktQuestionsUser/add.htm', this.$qs.stringify(params))
          .then(res => {
            var data = res.data;
            if (data.stat == '1') {
              sessionStorage.setItem('myanswerId', data.data)
              this.$message({
                message: '提交成功！',
                type: 'success'
              });
              loading.close();
              const {
                href
              } = this.$router.resolve({
                name: 'Ckjx',
                query: {}
              });
              window.open(href, '_blank');
              window.opener = null;
              window.open('', '_self');
              window.close();
            } else {
              this.$message.error(data.message);
            }
          })
      },
      getStlist: function(id, ksitype) {
        this.loading = true;
        const loading = this.$loading({
          lock: true,
          text: '试卷生成中，请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)',
          customClass: "loadclass"
        });
        this.$axios.post('/kt/ktPapersSet/createPlanSj.htm', this.$qs.stringify({
          id: id
        })).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.sjData = data.data;
            var list = [];
            var itypeList = [];
            data.data.list && data.data.list.map((item, i) => {
              list.push({
                ...item,
                myanswer: item.itype == '2' ? [] : ''
              });
              if (i == 0 || item.itype != data.data.list[i - 1].itype) {
                itypeList.push(item.itype)
              }
            });
            this.tiji = list;
            this.itypeList = itypeList;
            loading.close();
            this.$alert('试卷已生成，点击确定开始考试！', '生成试卷', {
              confirmButtonText: '确定',
              callback: action => {
                this.loading = false;
                this.fullPage();
              }
            });
          } else {
            this.$message.error(data.message);
          }
        })
      },
      goToTiji: function(i) {
        var el = document.getElementById('tijiid' + i);
        $('#ks-tiji-divA').animate({
          scrollTop: el.offsetTop
        }, 300);
      },
      fullPage: function() {
        var element = document.documentElement;
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        };
      },
      ysc: function() {
        this.loading = false;
        this.outerVisible = false;
        this.fullPage()
      }
    },
    components: {},
    created: function() {
      this.getStlist(sessionStorage.getItem('planId'), sessionStorage.getItem('productKsitype'));
      // 设置考试的开始时间
      var today = new Date();
      var year = today.getFullYear();
      this.startTime = format('YYYY-MM-DD hh:mm:ss');
      sessionStorage.setItem('startTime', this.startTime);
      var $this = this;

      window.addEventListener("resize", (() => {
        var isFull = document.fullscreenElement ||
          document.msFullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement || false;

        if (!isFull) {
          $this.$alert('不可退出全屏！', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              $this.fullPage();
            }
          });
        }
      }));
    },
    // 页面关闭之前   先提交试卷
    beforeDestroy: function() {
      if (!this.istj) {
        this.$confirm('关闭页面，试卷将自动提交，您确定要关闭该页面？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true,
          type: 'warning'
        }).then(() => {
          this.saveTj();
        }).catch(() => {});
      };
    },
    watch: {
      tiji: {
        handler(newVal) {
          this.getJincheng(newVal);
        },
        deep: true
      }
    }
  }
</script>

<style>
  .ks-title {
    background-color: #fff;
    border-radius: 4px;
  }

  .ks-title-top {
    opacity: 1;
    font-size: 24px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: center;
    color: #333333;
    line-height: 33px;
    padding: 25px 0;
    border-bottom: 1px solid #efefef;
    ;
  }

  .ks-title-bottom {
    margin: 30px 30px 0;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #333333;
    letter-spacing: 1px;
    padding-bottom: 30px;
  }

  .ks-title-bg {
    width: 1137px;
    height: 12px;
    opacity: 1;
    background: #efefef;
    border-radius: 7px;
    margin-bottom: 17px;
  }

  .ks-title-bg .progress {
    height: 12px;
    width: 20%;
    background: #0071BA;
    border-radius: 7px;
    transition: all 0.3s linear;
  }

  .ks-tiji {
    width: 853px;
    height: calc(100vh - 50px - 192px);
    overflow-y: auto;
  }

  .ks-ti-block {
    padding: 26px 40px 26px 66px;
    background: #ffffff;
    margin-bottom: 20px;
    position: relative;
  }

  .ks-ti-block-xh {
    position: absolute;
    width: 44px;
    height: 37px;
    background: url(../assets/images/ksxh.png) 0 0 no-repeat;
    background-size: 100% 100%;
    left: -10px;
    top: 21px;
    color: #fff;
    line-height: 29px;
    text-align: center;
  }

  .ks-ti-block-typeName {
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #0071BA;
    line-height: 20px;
    letter-spacing: 1px;
    padding-bottom: 8px;
  }

  .ks-ti-block-tiName {
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #333333;
    line-height: 20px;
    letter-spacing: 1px;
    margin-bottom: 22px;
  }

  /* 单选的样式   自定义 开始*/
  .radioTm {
    padding-bottom: 15px;
    text-align: left;
  }

  .radioTm .el-radio__inner {
    width: 24px;
    height: 24px;
    background: #efefef;
    border-radius: 50%;
  }

  .radioTm .el-radio__input.is-checked .el-radio__inner {
    background: #ff8b2e;
    border: 1px solid #ff8b2e;
  }

  .radioTm .el-radio__inner::after {
    background-color: transparent;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(1);
    color: #333;
    line-height: 24PX;
    text-align: center;
  }

  .radioTm0 .el-radio__inner::after {
    content: "A";
  }

  .radioTm1 .el-radio__inner::after {
    content: "B";
  }

  .radioTm2 .el-radio__inner::after {
    content: "C";
  }

  .radioTm3 .el-radio__inner::after {
    content: "D";
  }

  .radioTm .is-checked .el-radio__inner::after {
    color: #FFF;
  }

  .radioTm .el-radio__input.is-checked+.el-radio__label {
    color: #333;
  }

  /* 单选的样式   自定义 结束*/
  /* 多选的样式   自定义 开始*/
  .checkboxTm {
    text-align: left;
    padding-bottom: 15px;
  }

  .checkboxTm .el-checkbox__inner {
    width: 24px;
    height: 24px;
    background: #efefef;
    border-radius: 50%;
  }

  .checkboxTm .el-checkbox__inner::after {
    background-color: transparent;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(1);
    color: #333;
    line-height: 24PX;
    text-align: center;
  }

  .checkboxTm0 .el-checkbox__inner::after {
    content: "A";
  }

  .checkboxTm1 .el-checkbox__inner::after {
    content: "B";
  }

  .checkboxTm2 .el-checkbox__inner::after {
    content: "C";
  }

  .checkboxTm3 .el-checkbox__inner::after {
    content: "D";
  }

  .checkboxTm4 .el-checkbox__inner::after {
    content: "E";
  }

  .checkboxTm5 .el-checkbox__inner::after {
    content: "F";
  }

  .checkboxTm6 .el-checkbox__inner::after {
    content: "G";
  }

  .checkboxTm .el-checkbox__input.is-checked .el-checkbox__inner::after {
    transform: translate(-50%, -50%) scale(1);
    background-color: #ff8b2e;
    color: #fff;
  }

  .checkboxTm .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #ff8b2e;
  }

  .checkboxTm .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #ff8b2e;
    background-color: #ff8b2e;
  }

  .checkboxTm .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #333;
  }

  /* 多选的样式   自定义 结束*/
  /* 输入框样式 */
  .tiankong-inp .el-input {
    width: 100px;
    margin: 0 5px;
  }

  .tiankong-inp .el-input .el-input__inner {
    border: none;
    border-bottom: 1px solid #d0d0d0;
    border-radius: 0;
  }

  /* 输入框样式 */
  .ks-datika {
    width: 286px;
    background: #ffffff;
    padding: 20px;
    border-radius: 4px;
    height: calc(100vh - 91px - 192px);
    overflow-y: auto;
  }

  .ks-datika .ks-datika-name {
    font-size: 16px;
    font-family: 'PingFangSC';
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    letter-spacing: 1px;
  }

  .ks-datika-wcd {
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #9a9a9a;
    line-height: 20px;
    letter-spacing: 1px;
  }

  .small-block-yd {
    width: 14px;
    height: 14px;
    opacity: 1;
    background: #ff8b2e;
    border-radius: 1px;
    margin-right: 6px;
  }

  .small-block-wd {
    width: 14px;
    height: 14px;
    opacity: 1;
    background: #d8d8d8;
    border-radius: 1px;
    margin: 0 6px 0 14px;
  }

  .ti-type {
    margin: 12px 6px 12px 0;
    text-align: left;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #333333;
  }

  .ti-xuhao-block {
    width: 36px;
    height: 36px;
    background: #efefef;
    border-radius: 1px;
    color: #333;
    text-align: center;
    line-height: 36px;
    margin: 5px 5px;
    cursor: pointer;
  }

  .ti-xuhao-block.active {
    width: 36px;
    height: 36px;
    background: #ff8b2e;
    border-radius: 1px;
    color: #fff;
  }

  .tijiao-junazi {
    width: 100%;
    border-radius: 25px;
    font-size: 20px;
    font-family: 'PingFangSC';
    font-weight: 500;
  }

  .loadclass {
    font-size: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PlanKs.vue